import Account from '../account/account.js'
import Manifest from '../manifest.js'
import Storage from '../storage/storage.js'
import Utils from '../../utils/utils.js'
import TMDB from './tmdb.js'
import Settings from '../../interaction/settings/settings.js'
import Arrays from '../../utils/arrays.js'

function ImageMirror(){
    let stat    = []
    let mirrors = [
        'imagetmdb.com/',
        'nl.imagetmdb.com/',
        'de.imagetmdb.com/',
        'pl.imagetmdb.com/',
        'lampa.byskaz.ru/tmdb/img/'
    ]

    if(Account.hasPremium()) Arrays.insert(mirrors, 0, 'imagetmdb.'+ Manifest.cub_domain+'/')

    mirrors.forEach(mirror=>{
        stat[mirror] = {
            errors: [],
            banned: false
        }
    })


    this.current = function(){
        // Зеркало картинок выбираем заново каждый раз (первое неотбанённое),
        // в localStorage домен не храним — иначе застревает устаревший.
        // Бан конкретного зеркала живёт в памяти сессии (см. broken()).
        let free = mirrors.filter(mirror=>!stat[mirror].banned)

        return free.length ? free[0] : mirrors[0]
    }

    this.broken = function(url){
        mirrors.forEach(mirror=>{
            if(url && url.indexOf('://' + mirror) !== -1){
                let now = Date.now()
                let s   = stat[mirror]

                s.errors.push(now)
                s.errors = s.errors.filter(t => now - t < 10000);

                console.log('TMDB-Proxy','mirror', mirror, 'errors', s.errors.length)

                if(s.errors.length >= 20){
                    s.banned = true
                    s.errors = []

                    console.warn('TMDB-Proxy','mirror', mirror, 'banned')
                }
            }
        })
    }
}

function init(){
    let tmdb_proxy = {
        name: 'TMDB Proxy',
        version: '1.0.6',
        description: 'Проксирование постеров и API сайта TMDB',

        path_api: 'apitmdb.'+Manifest.cub_domain+'/3/',
        path_api_backup: 'lampa.byskaz.ru/tmdb/api/3/',
    }

    let IMG = new ImageMirror()

    function filter(u){
        let s = u.slice(0, 8)
        let e = u.slice(8).replace(/\/+/g,'/')

        return s + e
    }

    function email(){
        return Storage.get('account','{}').email || ''
    }

    TMDB.image = function(url){
        let base  = Utils.protocol() + 'image.tmdb.org/' + url

        return Utils.addUrlComponent(filter(Storage.field('proxy_tmdb') ? Utils.protocol() + IMG.current() + url : base), 'email=' + encodeURIComponent(email()))
    }

    TMDB.api = function(url){
        let base  = Utils.protocol() + 'api.themoviedb.org/3/' + url

        return Utils.addUrlComponent(filter(Storage.field('proxy_tmdb') ? Utils.protocol() + tmdb_proxy.path_api + url : base), 'email=' + encodeURIComponent(email()))
    }

    TMDB.broken = function(url){
        IMG.broken(url)
    }

    Settings.listener.follow('open', function (e) {
        if(e.name == 'tmdb'){
            e.body.find('[data-parent="proxy"]').remove()
        }
    })

    console.log('TMDB-Proxy','init')

    console.log('TMDB-Proxy', Storage.field('proxy_tmdb') ? 'enabled' : 'disabled')
}

export default {
    init
}